// eslint-disable-next-line import/no-anonymous-default-export
const it = {
  descriptionBold: 'Grazie per il tuo interesse.',
  description: 'Cerca e seleziona l\'appuntamento richiesto.',
  eventTypeTitles: {
    '': '',
    Youngster: 'Giovani (13 - 16 anni)',
    'Job Info Events': 'Eventi informativi sul lavoro',
    Visits: 'Visite guidate',
    'Recruitment Days (1d)': 'Giornate di reclutamento (1 g)',
    'Recruitment Days (1d+)': 'Giornate di reclutamento (1 g+)',
    Internal: 'Interno',
  },
  noEvents: 'Al momento non ci sono date disponibili. Pubblicheremo presto nuove date. Grazie per la vostra pazienza.',
  loadError: 'Al momento non è stato possibile caricare le date. Ricaricare la pagina o riprovare tra qualche minuto.',
  noGuidedTours: "Pubblicheremo presto nuove date. Grazie per la vostra pazienza. Nel frattempo potete contattarci tramite il seguente modulo: <1>Request a Guided Tour</1>",
  filters: {
    eventType: 'Modifica il tipo di evento',
    startDate: 'Da',
    endDate: 'Fino a',
    location: 'Luogo',
    languageLabel: 'Lingua',
    language: {
      title: 'Seleziona la lingua',
      en: 'Inglese',
      fr: 'Francese',
      it: 'Italiano',
      de: 'Tedesco',
    },
    search: 'Cerca',
    clear: 'Reimposta',
  },
  card: {
    startDate: 'Data di inizio:',
    startHour: 'Ora di inizio:',
    endDate: 'Data di fine:',
    endHour: 'Ora di fine:',
    until: 'fino a',
  },
  contact: 'Contatto',
  contactDesc: 'Hai domande? Non esitare a chiamarci al 043 931 6111 o a scriverci via email a',
  feast: {
    title: 'Registrazione al test FEAST 1',
    subtitle:
      "I test FEAST di Skyguide sono disponibili solo su invito e richiedono una candidatura preventiva. Se non l’hai ancora fatto, ti invitiamo a candidarti <1>qui</1> per la formazione corrispondente di controllore del traffico aereo.",
    filterTitle: 'Cerca e seleziona l’appuntamento richiesto.'
  },
  schoolOfCompetence: {
    title: 'School of Competence',
    subtitle: 'Scopri i workshop della School of Competence di skyguide e iscriviti a quello più adatto a te.',
    filterTitle: 'Cerca e seleziona l’appuntamento richiesto.',
    filterLabel: 'School of Competence',
  },
};

export default it;
